module.exports = __webpack_public_path__ + "img/btn_register.b18d4905.png";